
import React, { Component } from 'react';
import { render } from 'react-dom';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';

let resolve;

class DialogAlert extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogAlert />, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            message: '',
            options: {}
        };
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(false);
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                onDismiss={this.handleCancel}
                minWidth={this.state.options.minWidth || null}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: this.state.options.title || 'Upozornění'
                }}
                modalProps={{
                    isBlocking: false
                }}
                >
                <div dangerouslySetInnerHTML={{__html: this.state.message}} />
                <DialogFooter>
                    <DefaultButton onClick={this.handleCancel} text="Zavřít" />
                </DialogFooter>
            </Dialog>
        );
    }

    show(message, options) {
        this.setState({
            hidden: false,
            message: message,
            options: options || {}
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogAlert.create();
